var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#facebook_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.141 12.07C24.141 5.405 18.737 0 12.071 0 5.404 0 0 5.404 0 12.07c0 6.026 4.414 11.02 10.185 11.925V15.56H7.12v-3.49h3.065V9.412c0-3.025 1.802-4.696 4.559-4.696 1.32 0 2.702.236 2.702.236v2.97h-1.522c-1.5 0-1.967.93-1.967 1.885v2.265h3.348l-.536 3.489h-2.812v8.435c5.77-.906 10.184-5.9 10.184-11.924",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "facebook_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  })))));
}

var MemoSvgFacebook = /*#__PURE__*/React.memo(SvgFacebook);
export default MemoSvgFacebook;